import React, { useEffect, useState } from 'react'
import { Header } from 'Components'
import { Layout } from 'antd'
import styled from 'styled-components'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Breadcrumb from 'Components/breadcrumb'
import SideBar, { dataSideBar } from 'Components/siderBar'
import { useUserList } from 'Hooks'
import * as _ from 'lodash'

const { Content } = Layout

const Wrapper = styled.div`
  overflow: auto;
  .content {
    min-height: calc(100vh - 156px);
  }
  .svg.ant-menu-item-icon {
    color: black;
  }
  .sider-class {
    padding-top: 63px;
    height: 100vh;
    position: sticky;
    overflow: auto;
    left: 0;
    top: 0;
    bottom: 0;
    z-index: 999;
  }
  .collapse {
    width: 100%;
    max-height: 40px;
    line-height: 40px;
    text-align: left;
    box-shadow: inset 0 1px 0 #F0F0F0;
    padding: 0 16px;

    border: none;
    cursor: pointer;

    position: sticky;
    bottom: 0;
    background-color: white;
  }
  .ant-layout-sider-children {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  span.ant-breadcrumb-link {
    margin-bottom: 20px;
    font-weight: 700;
    font-size: 30px;
    line-height: 24px;
    color: #000000;
  }
  nav.ant-breadcrumb {
    margin-top: 10px;
    margin-bottom: 10px;
  }
`

const HomeLayout = ({ children }) => {
  const { t } = useTranslation('menu')
  const { idUser, idPortfolio } = useParams()
  const [dataBreadScum, setDataBreadScum] = useState([])
  const location = useLocation()
  const history = useHistory()
  const { info, getInfoUserAndPortfolioAction } = useUserList()

  const lastBread = (path) => {
    switch (path) {
      case 'dashboard':
        return t('menu:dashboard')
      case 'weekly':
        return t('menu:weekly_management')
      case 'head-count':
        return t('menu:headcount')
      default:
        return ''
    }
  }

  const getBreadScum = () => {
    let listBreadScum = []
    const path = location.pathname.split('/')
    if (path?.length === 2) {
      const side = dataSideBar(t).find((_item) => _item.to === `/${path[1]}`)
      const itemBread = {
        key: 1,
        text: side.label
      }
      listBreadScum.push(itemBread)
    } else if (path?.length === 6) {
      const itemBread = [
        {
          key: 'user-list',
          text: 'User List',
          to: '/user-list'
        },
        {
          key: 'account-info',
          text: info.userName,
          to: `/account-info/${idUser}`
        },
        {
          key: 'portfolio',
          text: info.portfolioName,
          to: `/user/${idUser}/portfolio/${idPortfolio}/${path[5]}`
        },
        {
          key: 'path',
          text: _.startCase(_.toLower(lastBread(path[5]))),
          to: `/user/${idUser}/portfolio/${idPortfolio}/${path[5]}`
        }
      ]
      listBreadScum = itemBread
    }

    setDataBreadScum(listBreadScum)
  }

  useEffect(() => {
    if (info) {
      getBreadScum()
    }
  }, [info])

  useEffect(() => {
    if (idUser && idPortfolio) {
      getInfoUserAndPortfolioAction({
        userId: idUser,
        portfolioId: idPortfolio
      })
    }
  }, [idUser, idPortfolio])

  return (
    <Wrapper>
      <Layout>
        <Header />
        <Layout>
          <SideBar />
          <Layout
            style={{
              padding: '17px 24px 24px',
              overflow: 'initial',
              minHeight: 'auto',
              marginTop: '63px',
              // width: '100%',
              zIndex: '1'
            }}
          >
            <Breadcrumb
              data={dataBreadScum}
              onSelectItem={(item) => {
                history.push(`${item.to}`)
              }}
            />
            <Content
              className="content"
            >
              {children}
            </Content>
          </Layout>
        </Layout>
      </Layout>
    </Wrapper>
  )
}

export default HomeLayout
